import { get } from 'lodash-es';
import { getApiEndpoint } from 'srcAlias/utils/url';
import { createHeaders } from 'srcAlias/utils/headers';
import config from 'configAlias';
import { fetch } from '@atlas/fetch';
import { store } from 'srcAlias/initialization';
export const callLogging = (userRedirectedFrom, userRedirectedTo) => {
  const appConfig = get(config, 'appConfig', {});
  const reduxState = store.getState();
  const sessionId = get(reduxState, 'sessionId', 'SESSION_ID_NOT_FOUND');
  const headersDetails = {
    applicationType: get(appConfig, 'applicationType'),
    channelId: get(appConfig, 'channelId'),
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
    sessionId: sessionId,
  };

  const apiEndpoint = getApiEndpoint();

  fetch(`${apiEndpoint}/api/etb/logging`, {
    method: 'POST',
    headers: {
      ...createHeaders(headersDetails),
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      sessionId,
      userRedirectedTo: userRedirectedTo,
      userRedirectedFrom: userRedirectedFrom,
    }),
  }).catch(() => {
    // DO NOTHING
  });
};
